export default {
  loginUIState: (state) => state.loginUIState
}